<template lang="pug">
  section
    header.header-settings
      .tabs
        .tab.primary-text.active
          span General

    form-upload(@uploaded="uploaded")
      div.form-field
        label
          h6 Logo
          .form-field-image(:class="{ 'has-image': logo }")
            .interact
              span
                font-awesome-icon.icon(:icon="['fad', 'file-image']")
            img#logo(v-if="logo", :src="logo", ref="logo", crossorigin="anonymous")

    div.form-field(v-if="logo")
      button.button.button-alert(type="button", @click="removeLogo") Remove Logo

    form(@keyup.enter="submit", @submit.prevent="submit")

      AlertBox(v-if="error", type="danger", :text="error")

      div.form-field(:class="{error: $v.form.name.$error, 'error-required': !$v.form.name.required}")
        label
          h6 Name
          input(type="text", minlength="2", maxlength="100", v-model="$v.form.name.$model")

      div.form-field(:class="{error: $v.form.subdomain.$error, 'error-required': !$v.form.subdomain.required}")
        label
          h6 Subdomain
          input(type="text", minlength="2", maxlength="25", v-model="$v.form.subdomain.$model")
      //-.row.field-split
        .col.max
          div.form-field
            label
              h6 Primary Color
              .form-field-color
                .hex
                  .input {{ form.primaryColor }}
                .picker
                  verte(picker="square", v-model="form.primaryColor", :draggable="false", model="hex")
                    color-swatch(:color="form.primaryColor")
        .col.max
          div.form-field
            label
              h6 Secondary Color
              .form-field-color
                .hex
                  .input {{ form.secondaryColor }}
                .picker
                  verte(picker="square", v-model="form.secondaryColor", :draggable="false", model="hex")
                    color-swatch(:color="form.secondaryColor")

      div.form-field
        SubmitButton(label="Save", :formState="formState")
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import FormUpload from '@/components/form/FormUpload'
import { form } from '@/mixins/form'

import ColorThief from 'colorthief'

import ColorSwatch from '@/components/helpers/ColorSwatch'

import Verte from 'verte'

export default {
  name: 'SettingsCompany',
  mixins: [form],
  components: {
    FormUpload,
    Verte,
    ColorSwatch
  },
  data () {
    return {
      formState: 'initial',
      form: {
      },
      error: null
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      subdomain: {
        required
      }
    }
  },
  beforeCreate () {
    this.$store.dispatch('getCompany')
      .then(() => {
        this.form = Object.assign({}, this.$store.state.company)
      })

  },
  mounted () {
    this.form = {}

    let palette = null

    const colorThief = new ColorThief();

    // console.log(this.$refs.logo)

    setTimeout(() => {
      const image = document.querySelector('#logo')
      // console.log(image)
      //image.addEventListener('load', function() {
        if(image){
          palette = colorThief.getPalette(image);
          //console.log(palette)
        }
      //})
    }, 1000)

    /*
    setTimeout(() => {
      const image = document.querySelector('#logo')
      console.log(image)
      if (image.complete) {
          color = ColorThief.getPalette(image);
          console.log(color)
      } else {
        image.addEventListener('load', function() {
          console.log('image loaded')
          color = ColorThief.getPalette(image);
          console.log(color)
        })

      }
    }, 1000)*/
  },
  computed: {
    logo () {
      let logo = this.form.logoUrl ? `${this.form.logoUrl}` : null
      return logo
    }
  },
  methods: {
    removeLogo () {
      this.$set(this.form, 'logoUrl', null)
    },
    uploaded (attachment) {
      this.$set(this.form, 'logoUrl', attachment.url)
    },
    submit () {
      if (this.__formInvalid()) return

      this.formState = 'pending'
      this.$store.dispatch('updateCompany', this.form)
        .then(() => {
          this.formState = 'success'
          this.$v.$reset()
        }, error => {
          this.error = error
          this.formState = 'initial'
        })
    }
  },
}
</script>

<style lang="stylus" scoped>

</style>
